export const CHECK_BOX_WIDTH = "43px";
export const USER_NAMES_COOKIE = 'teneraUserNames';